import { get, isEmpty, isNull } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Table from '../../../../../../../common/components/table/components/Table';
import laborTableConfig from '../constants/labor_table_config';
import { searchLaborGroupingAction } from '../redux/laborGrouping';
import { SUPPORTED_IMPORT_TYPES } from '../../../../../../import_data/constants/import_types';
import {
  getImportFailureNotification,
  getImportTypeMetadataForHeader,
  processUserLevelImportMetadata,
} from '../../../../../../import_data/utils/import_utils';
import { setPageNotification } from '../../../../../../../common/components/with_page/redux/reducer';
import { getImportMetadataAction } from '../../../../../../import_data/redux/GetImportMetadata';

const LaborTable = props => {
  const { importMetadata, pushNotification, data } = props;
  const supportedImportTypes = SUPPORTED_IMPORT_TYPES.LABOR_GROUPING;
  const [latestImportTypeMetadata, setLatestImportTypeMetadata] = React.useState(null);

  useEffect(() => {
    if (!isEmpty(importMetadata)) {
      const importTypeMetadata = getImportTypeMetadataForHeader(
        importMetadata,
        supportedImportTypes,
      );
      setLatestImportTypeMetadata(importTypeMetadata);

      const userLevelImportMetadata = processUserLevelImportMetadata(importMetadata);
      if (!isNull(userLevelImportMetadata)) {
        pushNotification(
          getImportFailureNotification({
            tableIdentifier: 'ValariGroupingTable',
            ...userLevelImportMetadata,
            supportedImportTypes,
          }),
        );
      }
    }
  }, [importMetadata, supportedImportTypes, pushNotification]);

  return (
    <Table
      {...props}
      config={laborTableConfig({ importTypeMetadata: latestImportTypeMetadata, data })}
    />
  );
};

LaborTable.propTypes = {
  schema: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  isFetchingData: PropTypes.bool.isRequired,
  getDataBegin: PropTypes.func.isRequired,
  clearData: PropTypes.func.isRequired,
  importMetadata: PropTypes.array.isRequired,
  pushNotification: PropTypes.func.isRequired,
  getImportDataBegin: PropTypes.func.isRequired,
  getImportDataClear: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    schema: get(state, 'entities.schemas.data.pages.grouping.labor', []) || [],
    data: get(state, 'entities.grouping.labor.data', {}) || {},
    isFetchingData: get(state, 'entities.grouping.labor.isFetching', false) || false,
    totalResultCount: get(state, 'entities.grouping.labor.data.totalResultCount', 0) || 0,
    importMetadata: get(state, 'entities.getImportMetadata.data.body.importMetadata', []) || [],
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getDataBegin: searchLaborGroupingAction.BEGIN,
      clearData: searchLaborGroupingAction.CLEAR,
      pushNotification: setPageNotification,
      getImportDataBegin: getImportMetadataAction.BEGIN,
      getImportDataClear: getImportMetadataAction.CLEAR,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(LaborTable);
